<template>
  <nav class="breadcrumb-v2" aria-label="breadcrumb">
    <template v-for="(item, index) in items">
      <router-link
        v-if="item.path"
        :key="item.name"
        :to="item.path"
      >
        {{ item.nameKey ? $t(item.nameKey) : item.name }}
      </router-link>
      <span v-else :key="item.name" class="breadcrumb-current">{{ item.nameKey ? $t(item.nameKey) : item.name }}</span>
      <span v-if="index < items.length - 1" :key="item.name + '-separator'" class="breadcrumb-separator">></span>
    </template>
  </nav>
</template>

<script>
export default {
  name: 'BreadcrumbV2',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
.breadcrumb-v2 {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin: -10px 0 30px;
  padding-bottom: 18px;
  border-bottom: 1px solid #e2e8f0;
  color: #94a3b8;
  font-size: 15px;
}

.breadcrumb-v2 a {
  position: relative;
  color: #64748b;
  font-weight: 500;
  transition: color 0.2s;

  &:hover {
    color: #ef0012;
  }
}

.breadcrumb-current {
  color: #ef0012;
  font-weight: 700;
}

.breadcrumb-separator {
  width: 5px;
  height: 5px;
  overflow: hidden;
  color: transparent;
  border-top: 1px solid #cbd5e1;
  border-right: 1px solid #cbd5e1;
  transform: rotate(45deg);
}

@media (max-width: 640px) {
  .breadcrumb-v2 {
    margin-top: 0;
    font-size: 14px;
  }
}
</style>
